//formatter函数将数据取绝对值
export default {
  methods: {
    formaterValToAbsPlugin(opt) {
      opt.xAxis.axisLabel.formatter = params => Math.abs(params)
      let newToolTip = function (params) {
        let str = params[0].axisValue + "</br>"
        params.forEach(item => {
          str += item.marker + item.seriesName + '<span style="margin-left:30px;float:right;">' + Math.abs(item.value) + '</span>' + "</br>"
        })
        return str
      }
      opt.tooltip.formatter = newToolTip
      let valueUnit = []
      let newSeries = function (params) {
        let str
        if (opt.pluginName.includes("formaterValToAbsPlugin")) {// 双向切正负柱状图时页面没渲染会进来
          str = Math.abs(params.value) + valueUnit[params.seriesIndex]
        } else {
          str = params.value + valueUnit[params.seriesIndex]
        }
        return str
      }
      opt.series.forEach((item, index) => {
        let formatter = item.label.formatter
        if (item.hasOwnProperty("unit")) {
          valueUnit[index] = item.unit
        } else if (formatter) {
          const start = formatter.indexOf("|") + 1
          valueUnit[index] = formatter.slice(start, -1)
        }
        item.unit = valueUnit[index]
        item.label.formatter = newSeries
      })
    },
  }
}